'use client'

import { NoContentData } from '@lastbrand/storefront-proto-registry/api/v1/widget'
import { useCallback } from 'react'

import { NoContentDS } from '@src/components/blocks/no-content-ds'
import { PLTypedWidgetProps } from '@src/components/pl-base-widget'
import { useFilterSortContext } from '@src/pages/clp1/contexts/filter-sort-context'

/** DS branch of the PL `NO_CONTENT` widget. Pure data-translation; the block owns presentation + telemetry. */
export function NoContentDSWidget(props: PLTypedWidgetProps<NoContentData>) {
  const { clearAllFilters } = useFilterSortContext()
  const filtersApplied = props.data.noContentData?.filtersApplied ?? false

  // Parameterless on purpose — `clearAllFilters` ignores its arg (only reads `preserveScrollPosition`).
  const handleResetFilters = useCallback(() => {
    clearAllFilters()
  }, [clearAllFilters])

  return <NoContentDS onResetFilters={handleResetFilters} isFiltersApplied={filtersApplied} />
}
